<template>
	<div class="max-w-2xl w-full p-6">
		<div class="flex justify-center pb-8">
			<Breadcrumb
				v-model="step"
				:crumbs="[
					{ name: 'Cadastro', step: 1 },
					{ name: 'Planejamento', step: 2 },
				]"
			/>
		</div>
		<div class="flex flex-col gap-2 pb-8">
			<h1 class="text-H5">Planejamento</h1>
			<p class="text-default">Preencha as informações para configurar a distribuição diamétrica</p>
		</div>
		<div class="flex flex-col gap-4">
			<Dropdown
				v-model="planejamentoCubagem.medicaoId"
				:options="medicoesDoEstrato"
				label="medição *"
				:disabled="dadosPlanejamentoCubagem !== undefined"
				@input="changedMedicaoId"
			>
				<template #tooltip>
					<div class="w-fit block">
						<Tooltip :options="{ placement: 'top' }">
							<template #trigger>
								<Icon
									icon="octicon:question-16"
									class="text-sm text-gray-medium"
								/>
							</template>
							<div class="flex flex-col gap-2 max-w-xs p-2">
								<p class="text-s-bold">Medição</p>
								<p class="text-s">
									Selecione uma medição de referência para gerar as pré definições de cubagem
								</p>
							</div>
						</Tooltip>
					</div>
				</template>
			</Dropdown>
			<Input
				v-model.number="limiteInferior"
				type="number"
				:label="`${labelsTipoMedicao.valorMin} *`"
				placeholder="Digite aqui"
			>
				<template #tooltip>
					<div class="w-fit block">
						<Tooltip :options="{ placement: 'top' }">
							<template #trigger>
								<Icon
									icon="octicon:question-16"
									class="text-sm text-gray-medium"
								/>
							</template>
							<div class="flex flex-col gap-2 max-w-xs p-2">
								<p class="text-s-bold">
									{{ labelsTipoMedicao.valorMin }}
								</p>
								<p class="text-s">
									Defina o {{ labelsTipoMedicao.valorMin }} para a coleta de cubagem
								</p>
							</div>
						</Tooltip>
					</div>
				</template>
			</Input>
			<Input
				v-model.number="limiteSuperior"
				type="number"
				:label="`${labelsTipoMedicao.valorMax} *`"
				placeholder="Digite aqui"
			>
				<template #tooltip>
					<div class="w-fit block">
						<Tooltip :options="{ placement: 'top' }">
							<template #trigger>
								<Icon
									icon="octicon:question-16"
									class="text-sm text-gray-medium"
								/>
							</template>
							<div class="flex flex-col gap-2 max-w-xs p-2">
								<p class="text-s-bold">
									{{ labelsTipoMedicao.valorMax }}
								</p>
								<p class="text-s">
									Defina o {{ labelsTipoMedicao.valorMax }} para a coleta de cubagem
								</p>
							</div>
						</Tooltip>
					</div>
				</template>
			</Input>
			<Input
				v-model.number="planejamentoCubagem.totalArvoresCubagem"
				type="number"
				label="total de árvores para cubar *"
				placeholder="Digite aqui"
			>
				<template #tooltip>
					<div class="w-fit block">
						<Tooltip :options="{ placement: 'top' }">
							<template #trigger>
								<Icon
									icon="octicon:question-16"
									class="text-sm text-gray-medium"
								/>
							</template>
							<div class="flex flex-col gap-2 max-w-xs p-2">
								<p class="text-s-bold">Total de árvores para cubar</p>
								<p class="text-s">
									Defina quantas árvores devem ser cubadas para a Ordem de Serviço. Através desse
									número e das demais configurações será definido o número de árvores por classe.
								</p>
							</div>
						</Tooltip>
					</div>
				</template>
			</Input>
			<Input
				v-model.number="planejamentoCubagem.numeroClasses"
				type="number"
				label="número de classes *"
				placeholder="Digite aqui"
			>
				<template #tooltip>
					<div class="w-fit block">
						<Tooltip :options="{ placement: 'top' }">
							<template #trigger>
								<Icon
									icon="octicon:question-16"
									class="text-sm text-gray-medium"
								/>
							</template>
							<div class="flex flex-col gap-2 max-w-xs p-2">
								<p class="text-s-bold">Número de classes</p>
								<p class="text-s">
									Defina quantas classes devem existir para a coleta de cubagem. Esse número
									atrelado ao total de árvores, determina a quantidade de árvores por classe.
								</p>
							</div>
						</Tooltip>
					</div>
				</template>
			</Input>
			<Input
				v-model.number="planejamentoCubagem.amplitudeClasses"
				type="number"
				label="amplitude de classes"
				placeholder="Digite aqui"
			>
				<template #tooltip>
					<div class="w-fit block">
						<Tooltip :options="{ placement: 'top' }">
							<template #trigger>
								<Icon
									icon="octicon:question-16"
									class="text-sm text-gray-medium"
								/>
							</template>
							<div class="flex flex-col gap-2 max-w-xs p-2">
								<p class="text-s-bold">Amplitude de classes</p>
								<p class="text-s">
									Defina a amplitude, ou seja, o tamanho do intervalo que deve conter cada classe.

									<strong class="mt-2">Exemplo:</strong> Para uma amplitude 1 o intervalo da classe
									será de 1 (10.00 cm - 11.00 cm)
								</p>
							</div>
						</Tooltip>
					</div>
				</template>
			</Input>
			<Input
				v-if="false"
				v-model.number="planejamentoCubagem.geofenceEstrato"
				type="number"
				label="geofence estrato"
				placeholder="Digite aqui"
			>
				<template #tooltip>
					<div class="w-fit block">
						<Tooltip :options="{ placement: 'top' }">
							<template #trigger>
								<Icon
									icon="octicon:question-16"
									class="text-sm text-gray-medium"
								/>
							</template>
							<div class="flex flex-col gap-2 max-w-xs p-2">
								<p class="text-s-bold">Geofence de Estrato</p>
								<p class="text-s">
									O geofence de estrato é utilizado para definir a distância mínima que o coletor
									deve estar daquele estrato para realizar a coleta
								</p>
							</div>
						</Tooltip>
					</div>
				</template>
			</Input>
			<Input
				v-if="false"
				v-model.number="planejamentoCubagem.geofenceParcela"
				type="number"
				label="geofence parcela"
				placeholder="Digite aqui"
			>
				<template #tooltip>
					<div class="w-fit block">
						<Tooltip :options="{ placement: 'top' }">
							<template #trigger>
								<Icon
									icon="octicon:question-16"
									class="text-sm text-gray-medium"
								/>
							</template>
							<div class="flex flex-col gap-2 max-w-xs p-2">
								<p class="text-s-bold">Geofence de Parcela</p>
								<p class="text-s">
									O geofence de parcela é utilizado para definir a distância mínima que o coletor
									deve estar daquela parcela para realizar a coleta
								</p>
							</div>
						</Tooltip>
					</div>
				</template>
			</Input>
			<Input
				v-if="false"
				v-model.number="planejamentoCubagem.geofenceArvore"
				type="number"
				label="geofence árvore"
				placeholder="Digite aqui"
			>
				<template #tooltip>
					<div class="w-fit block">
						<Tooltip :options="{ placement: 'top' }">
							<template #trigger>
								<Icon
									icon="octicon:question-16"
									class="text-sm text-gray-medium"
								/>
							</template>
							<div class="flex flex-col gap-2 max-w-xs p-2">
								<p class="text-s-bold">Geofence de Árvore</p>
								<p class="text-s">
									O geofence de árvore é utilizado para validar a distância mínima entre as árvores
									cubadas para aquela parcela
								</p>
							</div>
						</Tooltip>
					</div>
				</template>
			</Input>
			<Dropdown
				v-model="planejamentoCubagem.metodologiaCubagem"
				:options="[
					{ label: 'Posições fixas', value: 'DISTANCIAS_FIXAS' },
					{ label: 'Posições relativas', value: 'DISTANCIAS_RELATIVAS' },
				]"
				label="metodologia de cubagem"
			>
				<template #tooltip>
					<div class="w-fit block">
						<Tooltip :options="{ placement: 'top' }">
							<template #trigger>
								<Icon
									icon="octicon:question-16"
									class="text-sm text-gray-medium"
								/>
							</template>
							<div class="flex flex-col gap-2 max-w-xs p-2">
								<p class="text-s-bold">Metodologia de Cubagem</p>
								<p class="text-s flex flex-col gap-2">
									<span>Selecione a metodologia para realização da cubagem rigorosa.</span>

									<span
										><strong>Posições fixas:</strong> A altura da coleta das secções é fixa e
										determinadas pelo campo “Distância entre medições” independente do tamanho da
										árvore.</span
									>

									<span
										><strong>Posições relativas:</strong> A altura de coleta das secções é gerada
										proporcionalmente de acordo com a altura da árvore nas seguintes porcentagens:
										0, 1, 2, 3, 4, 5, 10, 15, 25, 35, 45, 55, 65, 75, 85, 95.</span
									>

									<span
										>Independente da metodologia escolhida, a secção na altura do peito (1,3m) é
										coletada obrigatoriamente</span
									>
								</p>
							</div>
						</Tooltip>
					</div>
				</template>
			</Dropdown>
			<Dropdown
				v-if="planejamentoCubagem.metodologiaCubagem === 'DISTANCIAS_FIXAS'"
				v-model="planejamentoCubagem.distanciaMedicoes"
				:options="[
					{ label: 'a cada 1 metro', value: 'UM_METRO' },
					{ label: 'a cada 2 metros', value: 'DOIS_METROS' },
				]"
				label="distância entre medições"
			>
				<template #tooltip>
					<div class="w-fit block">
						<Tooltip :options="{ placement: 'top' }">
							<template #trigger>
								<Icon
									icon="octicon:question-16"
									class="text-sm text-gray-medium"
								/>
							</template>
							<div class="flex flex-col gap-2 max-w-xs p-2">
								<p class="text-s-bold">Distância entre medições</p>
								<p class="text-s">
									Define para a metodologia de posições fixas a cada quantos metros a medição da
									secção deve ser coletada
								</p>
							</div>
						</Tooltip>
					</div>
				</template>
			</Dropdown>
			<div class="flex flex-col gap-2">
				<div class="flex gap-1 items-center">
					<label class="text-label">diâmetro de referência *</label>

					<div class="w-fit block">
						<Tooltip :options="{ placement: 'top' }">
							<template #trigger>
								<Icon
									icon="octicon:question-16"
									class="text-sm text-gray-medium"
								/>
							</template>
							<div class="flex flex-col gap-2 max-w-xs p-2">
								<p class="text-s-bold">Diâmetro de referência</p>
								<p class="text-s">
									Determina qual a ferramenta que será utilizada para a medição da árvore em pé, ou
									seja, para a medição de 1,3m antes de iniciar as secções
								</p>
							</div>
						</Tooltip>
					</div>
				</div>
				<Radio
					v-model="planejamentoCubagem.diametroReferencia"
					label="Fita"
					name="diametro"
					model-value="CAP"
				/>
				<Radio
					v-model="planejamentoCubagem.diametroReferencia"
					label="Suta"
					name="diametro"
					model-value="DAP"
				/>
			</div>

			<ToggleSwitch
				id="uniforme"
				v-model="planejamentoCubagem.distribuicaoUniforme"
				label="Distribuição uniforme"
			/>
			<ToggleSwitch
				id="arredondar"
				v-model="planejamentoCubagem.arredondarClasses"
				label="Arredondar classes"
			/>

			<div class="flex flex-col w-full gap-4">
				<Button
					text="restaurar parâmetros"
					secondary
					outline
					class="!border-none justify-center"
					@click="restaurar"
				/>
				<div class="flex w-full gap-4">
					<Button
						class="w-1/2 justify-center"
						text="cancelar"
						secondary
						@click="router.push('/ordemdeservico')"
					/>
					<Button
						:disabled="!ableToSave"
						class="w-1/2 justify-center"
						text="salvar"
						@click="salvarPlanejamento"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { Icon } from '@iconify/vue2'
import { computed, onMounted, ref } from 'vue'
import Breadcrumb from '../../../components/ui/breadcrumb/Breadcrumb.vue'
import Button from '../../../components/ui/button/Button.vue'
import Dropdown from '../../../components/ui/dropdown/Dropdown.vue'
import Input from '../../../components/ui/input/Input.vue'
import Radio from '../../../components/ui/radio/Radio.vue'
import ToggleSwitch from '../../../components/ui/switch/ToggleSwitch.vue'
import Tooltip from '../../../components/ui/tooltip/Tooltip.vue'
import { usePlanejamentoCubagem } from '../../../composables/usePlanejamentoCubagem'
import { getDropdownMedicaoPorEstratoFlorestal } from '../../../services/requests/MedicoesInventarioRequests'
import i18n from '../../../VueI18n'

const step = ref(2)

import { useRouter } from 'vue-router/composables'

const router = useRouter()

const {
	planejamentoCubagem,
	restaurar,
	salvarPlanejamento,
	estratoFlorestalId,
	changedMedicaoId,
	dadosPlanejamentoCubagem,
	limiteSuperior,
	limiteInferior,
	ableToSave,
} = usePlanejamentoCubagem()

const medicoesDoEstrato = ref([])

const labelsTipoMedicao = computed(() => {
	if (planejamentoCubagem.value.showAsDAP) {
		return {
			valorMin: i18n.t('minimumHBD') + ' (cm)',
			valorMax: i18n.t('maximumHBD') + ' (cm)',
			graficoEixoX: i18n.t('hbdInterval') + '(cm)',
		}
	} else {
		return {
			valorMin: i18n.t('minimumHBC'),
			valorMax: i18n.t('maximumHBC'),
			graficoEixoX: i18n.t('hbcInterval') + '(cm)',
		}
	}
})

onMounted(() => {
	getDropdownMedicaoPorEstratoFlorestal(estratoFlorestalId.value).then((response) => {
		medicoesDoEstrato.value = response.map((medicao) => {
			return { label: `${medicao['Código']} - ${medicao['Descrição']}`, value: medicao.id }
		})
	})
})
</script>

<style></style>
